<template>
  <LogPopupTemplate ref="logPopup" />

  <div>
    <strong>{{ info }}</strong>
    <DxDataGrid
      key-expr="id"
      :show-borders="true"
      :column-auto-width="true"
      :data-source="detail"
    >
      <!-- :focused-row-enabled="true" -->
      <DxFilterRow :visible="true" apply-filter="auto" />
      <DxColumn data-field="pegawai.nik" caption="NIK" />
      <DxColumn data-field="pegawai.nama" caption="Nama Peserta" />
      <DxColumn data-field="jabatan_print" caption="Jabatan" />
      <DxColumn type="buttons" :width="110">
        <DxButtonDataGrid
          hint="View Log Perubahan"
          icon="clock"
          :visible="true"
          @click="this.$refs.logPopup.showBySubject($event, 'DiklatPegawai')"
        />
      </DxColumn>
    </DxDataGrid>
  </div>
</template>

<script>
import LogPopupTemplate from "./LogPopupTemplate.vue";
import {
  DxDataGrid,
  DxColumn,
  DxFilterRow,
  DxButton as DxButtonDataGrid,
} from "devextreme-vue/data-grid";
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxFilterRow,
    DxButtonDataGrid,
    LogPopupTemplate,
  },
  props: {
    detail: {
      type: Array,
      required: true,
    },
    info: {
      type: String,
      required: true,
    },
  },
  data() {
    return { logPopupRef: null };
  },
  methods: {},
};
</script>
